function boxScaleAndShow (item, progress) {
    const scale = Math.min(1, (progress + 0.6))
    item.el.style.transform = `scale(${scale})`
    item.el.style.opacity = progress
  }
  
  function pipeScale (item, progress) {
    item.el.style.transform = `scaleY(${progress})`
  }
  
  export default [
    {
      type: 'box',
      thresholdStart: 0.2,
      thresholdEnd: 0.4,
      callback: boxScaleAndShow
    },
    {
      type: 'pipe',
      thresholdStart: 0.1,
      thresholdEnd: 0.3,
      callback: pipeScale
    },
    {
      type: 'experiment',
      thresholdStart: 0.8,
      classToAdd: 'show-experiment'
    },
    {
      type: 'envelope',
      thresholdStart: 0.8,
      classToAdd: 'show-envelope'
    },
    {
      type: 'bulb',
      thresholdStart: 0.8,
      classToAdd: 'show-bulb'
    },
    {
      type: 'hoop',
      thresholdStart: 0.8,
      classToAdd: 'show-hoop'
    },
    {
      type: 'opacity',
      thresholdStart: 0.8,
      classToAdd: 'show-from-scroll-opacity'
    }
  ]
  